import { CompanyContext } from "contexts/CompanyContext";
import { useContext, useEffect, useRef } from "react";
import { socialNetworks } from "views/calendar/SocialNetworkSidePanel";
import PostArticleSocialNoCreated from "./PostArticleSocialNoCreated";
import PostArticleSocialCreated from "./PostArticleSocialCreated";
import { getSocialNetworkIntegration } from "utils/getSocialNetworkIntegration";

const PostArticleSocials = ({
    status,
    posts,
    activeSocialNetwork,
    setActiveSocialNetwork,
    onCreateNetworkPost,
    isEditable,
    postGroup,
    onDeleteNetworkPost,
    onReplaceNetworkPost,
    validationErrors
}) => {

    const { companySocials } = useContext(CompanyContext);
    const scrollRef = useRef(null);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;
        const handleWheel = (e) => {
            if (!el.isConnected) return;
            // Horizontal trackpad swipes (deltaX-dominant) already scroll natively
            if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
            // Only hijack if the strip can still move in that direction,
            // so the page resumes scrolling when the tabs hit either end
            const canScroll = e.deltaY > 0
                ? el.scrollLeft + el.clientWidth < el.scrollWidth - 1
                : el.scrollLeft > 0;
            if (!canScroll) return;
            e.preventDefault();
            el.scrollLeft += e.deltaY;
        };
        // Native non-passive listener: React's onWheel is passive, so preventDefault() is ignored there
        el.addEventListener('wheel', handleWheel, { passive: false });
        return () => el.removeEventListener('wheel', handleWheel);
    }, []);

    return (
        <div className="relative">
            <div ref={scrollRef} className="relative flex items-stretch !bg-secondary-200 divide-tertiary-50 dark:!bg-gray-700 overflow-x-auto whitespace-nowrap flex-nowrap !h-[52px] no-scrollbar transition-all divide-x  dark:divide-gray-800">
                {[...new Set(posts?.map((post) => post?.network))].map((network) => (
                    <PostArticleSocialCreated 
                        network={network}
                        networkPosts={posts?.filter((post) => post.network == network)}
                        activeSocialNetwork={activeSocialNetwork}
                        setActiveSocialNetwork={setActiveSocialNetwork}
                        onDeleteNetworkPost={onDeleteNetworkPost}
                        onReplaceNetworkPost={onReplaceNetworkPost}
                        networkValidationErrors={validationErrors?.filter(e => e.network == network)}
                        postGroup={postGroup}
                        isEditable={isEditable}
                        posts={posts}
                    />
                ))}
                {isEditable && socialNetworks.sort((a, b) => +(!getSocialNetworkIntegration(a, companySocials)) - +(!getSocialNetworkIntegration(b, companySocials))).filter(cs => ![...new Set(posts?.map((post) => post?.network))].includes(cs)).map((network) => (
                    <PostArticleSocialNoCreated 
                        posts={posts}
                        network={network}
                        activeSocialNetwork={activeSocialNetwork}
                        onCreateNetworkPost={onCreateNetworkPost}
                        postGroup={postGroup}
                    />
                ))}
            </div>
            <div className="absolute right-0 top-0 h-full w-8 bg-gradient-to-l from-secondary-300 dark:from-gray-900/80 pointer-events-none animate-pulse"></div>
            <div className="absolute left-0 top-0 h-full w-8 bg-gradient-to-r from-secondary-300 dark:from-gray-900/80 pointer-events-none animate-pulse"></div>
        </div>
    )
}

export default PostArticleSocials;